export class Version {
  private static regex = /\d+\.\d+/;

  versionString: string;
  major: number = 0;
  minor: number = 0;

  constructor(versionNumber: string | number) {
    this.versionString = '' + versionNumber;

    if (!this.isValid()) {
      this.versionString = '0.0';
    }

    this.parse(this.versionString);
  }

  parse(versionString: string): void {
    const parts = versionString.split('.');
    this.major = parseInt(parts[0]);
    this.minor = parseInt(parts[1]);
  }

  isValid(): boolean {
    if (!this.versionString.match(Version.regex)) {
      return false;
    }

    const parts = this.versionString.split('.');

    if (parts.length !== 2) {
      return false;
    }

    return true;
  }

  isGreaterThan(version: Version): boolean {
    if (this.major > version.major) {
      return true;
    }

    if (this.major < version.major) {
      return false;
    }

    return this.minor > version.minor;
  }
}
